import type { BaseLayoutProps } from '../../types';

import * as React from 'react';
import dynamic from 'next/dynamic';
import { DefaultLayout } from '../DefaultLayout';

// IMPORTANT: The page.name in the import and switch case must match with the pageType set in the BaseLayoutProps definition!
import { Layout as LayoutGame } from '../../generated/game/layout';
const NavigationBar = dynamic<any>(() => import('../../components/NavigationBarB').then((mod) => mod.NavigationBarB), { ssr: true });
const FooterBar = dynamic<any>(() => import('../../components/FooterBarB').then((mod) => mod.FooterBarB), { ssr: true });

export function BaseLayout(props: BaseLayoutProps) {
  const { children, pageType, pageContext } = props;
  return (
    <>
      <NavigationBar/>
      {(() => {
        switch (pageType) {
          case 'game':
            return <LayoutGame pageContext={pageContext}>{children}</LayoutGame>;
          default:
            return <DefaultLayout pageContext={pageContext}>{children}</DefaultLayout>;
        }
      })()}
      <FooterBar/>
    </>
  );
}
